module.exports = __webpack_public_path__ + "static/img/bigSolid.8700608a.png";